import { Box } from '../../../../../mads';

import { spacing } from '@indeed/ifl-tokens/react-native';
import React from 'react';
import { StyleSheet } from 'react-native';

interface YouTubeVideoPlayerProps {
    videoId: string;
}

/**
 * YouTube video player component (web).
 * Uses a native iframe embed for the web platform.
 */
export function YouTubeVideoPlayer({ videoId }: YouTubeVideoPlayerProps) {
    const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`;
    return (
        <Box sx={styles.videoContainer}>
            <iframe
                src={embedUrl}
                style={{ width: '100%', height: '100%', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </Box>
    );
}

const styles = StyleSheet.create({
    videoContainer: {
        width: '100%',
        aspectRatio: 16 / 9,
        marginVertical: spacing.s3,
    },
});
